<template>
	<div class="container">
    <div>
      <form class="rent-form">
        <div class="rent-form__part rent-form__part--top">
          <div class="rent-form__fields">
            <div class="rent-form__field-box">
              <div class="rent-form__field-group rent-form__field-group--skeleton">
                <input type="text" class="form-control rent-form__location" disabled="" value="Начало аренды">
              </div>
            </div>
          </div>
        </div>
        <div class="rent-form__part rent-form__part--middle">
          <div class="rent-form__fields">
            <div class="rent-form__field-box">
              <div class="rent-form__field-group rent-form__field-group--skeleton">
                <input type="text" class="form-control rent-form__location" disabled="" value="Окончание аренды">
              </div>
            </div>
          </div>
        </div>
        <div class="rent-form__group">
          <div class="rent-form__part rent-form__part--small">
            <div class="rent-form__fields">
              <div class="rent-form__field-box">
                <div class="rent-form__field-group rent-form__field-group--skeleton  rent-form__field-group--skeleton-mini">
                  <div class="rent-form__datetime">
                    <input class="form-control rent-form__date" disabled=""> <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rent-form__part rent-form__part--small">
            <div class="rent-form__fields">
              <div class="rent-form__field-box">
                <div class="rent-form__field-group rent-form__field-group--skeleton  rent-form__field-group--skeleton-mini">
                  <div class="rent-form__datetime">
                    <input class="form-control rent-form__date"> <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <Loader class="w-100"/>
  </div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
	name: 'MobileLoading',
	components: {
	  Loader,
	},
}
</script>